import React, { FC, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { loginEntraId } from '../services/userApi/User';
import MediumTypography from '../components/formlib/MediumTypography';
import { Box } from '@mui/system';
import {
  SSO_REDIRECT_URI,
  STORAGE_USER_ID_KEY,
  STORAGE_USERFIRSTNAME_KEY,
  STORAGE_USERLASTNAME_KEY,
  STORAGE_USERNAME_KEY,
} from '../services/Constant';
import { Context } from '../LanguageWrapper';
import dayjs from 'dayjs';

interface AuthPropType {
  onLoginSuccess: (userId: string) => void;
}

export interface AuthBody {
  code: string;
  redirectUri: string;
  grantType: string;
  refreshToken?: string;
  timezone?: string;
}

const AuthScreen: FC<AuthPropType> = ({ onLoginSuccess }) => {
  const context = useContext(Context);
  const navigation = useNavigate();
  useEffect(() => {
    const params = new URLSearchParams(globalThis.location.search);
    const code = params.get('code');
    if (code) {
      submit(code);
    }
  }, []);

  const submit = async (codeValue: string) => {
    const timezone = dayjs(new Date()).format('Z');
    const userparams: AuthBody = {
      code: codeValue,
      redirectUri: `${SSO_REDIRECT_URI}auth`,
      grantType: 'password',
      timezone: timezone,
    };

    loginEntraId(userparams)
      .then(async (response) => {
        if (response?.programList) {
          localStorage.setItem('accessToken', response.accessToken);
          localStorage.setItem('refreshToken', response.refreshToken);
          localStorage.setItem('offlineToken', response.offlineToken);
          localStorage.setItem(STORAGE_USERFIRSTNAME_KEY, response.firstName);
          localStorage.setItem(STORAGE_USERLASTNAME_KEY, response.lastName);
          localStorage.setItem(STORAGE_USERNAME_KEY, response.name);
          localStorage.setItem(STORAGE_USER_ID_KEY, response.userId);
          localStorage.setItem('refreshTokenExpiry', response.refreshExpiresIn);
          localStorage.setItem('superProgramId', response.superProgramId);
          localStorage.setItem(
            'defaultProgramId',
            response.defaultProgramId ?? '',
          );
          context.updatePrograms(response.programList);
          context.updateSelectedProgram(
            response.defaultProgramId
              ? response.programList.find(
                  (program) => program.id === response.defaultProgramId,
                ) ?? response.programList[0]
              : response.programList[0],
            false,
          );

          navigation('/');
          onLoginSuccess(response.userId);
        }
      })
      .catch((error) => {
        console.log('error', error);
      });
  };

  return (
    <Box>
      <MediumTypography label="Loading" />
    </Box>
  );
};

export default AuthScreen;
